<template>
    <el-dialog :title="uuid ? '编辑' : '添加'" :visible.sync="dialogVisible" width="900px">
        <el-form :rules="rules" ref="dataForm" :model="temp" label-width="120px">
            <el-form-item label="文章标题" prop="title">
                <el-input v-model="temp.title"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="网站来源">
                        <el-select
                            clearable
                            style="width: 200px"
                            class="filter-item"
                            v-model="temp.source"
                        >
                            <el-option
                                v-for="item in sourceOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="来源网址">
                        <el-input v-model="temp.link"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="报考院校">
                        <el-select
                            clearable
                            filterable
                            style="width: 200px"
                            class="filter-item"
                            v-model="temp.school"
                            @change="handleSchool"
                        >
                            <el-option
                                v-for="item in schoolOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="报考专业" v-if="temp.school">
                        <el-select
                            clearable
                            filterable
                            style="width: 260px"
                            class="filter-item"
                            v-model="temp.sch_maj"
                        >
                            <el-option
                                v-for="item in majorOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="作者姓名">
                        <el-input style="width: 200px" v-model="temp.author"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发表时间">
                        <el-date-picker
                            v-model="temp.release_time"
                            type="date"
                            value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="文章正文">
                <Editor v-model="temp.content"></Editor>
            </el-form-item>
            <el-form-item label="添加标签">
                <el-input v-model="temp.label"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveData">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import checkPermission from "@/utils/permission";
import Editor from "@/components/Editor";
import { getDetail, add, edit } from "@/api/article";
import { getSchool, getMajorRemoval } from "@/api/common";

export default {
    name: "Edit",
    data() {
        return {
            uuid: "",
            dialogVisible: false,
            schoolOptions: null,
            majorOptions: null,
            yearName: "",
            temp: {
                title: "",
                source: null,
                link: "",
                school: "",
                sch_maj: "",
                author: "",
                release_time: null,
                content: "",
                label: ""
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "必填项不能为空",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    components: {
        Editor
    },
    props: ["sourceOptions"],
    created() {},
    methods: {
        checkPermission,

        fetchSchool(year) {
            getSchool(year).then(res => {
                this.schoolOptions = res;
            });
        },
        // 获取专业
        handleSchool(val) {
            getMajorRemoval(val, this.yearName).then(res => {
                this.majorOptions = res;
            });
        },
        // 添加
        handleAdd(year) {
            this.uuid = "";
            this.yearName = year;
            this.temp = {
                title: "",
                source: null,
                link: "",
                school: "",
                sch_maj: "",
                author: "",
                release_time: null,
                content: "",
                label: ""
            };
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
            this.fetchSchool(year);
            this.dialogVisible = true;
        },
        // 编辑
        handleEdit(year, uuid) {
            this.yearName = year;
            this.uuid = uuid;
            this.fetchSchool(year);
            getDetail(uuid).then(res => {
                this.temp = res.data;
                if (this.temp.school) {
                    new Promise((resolve, reject) => {
                        getMajorRemoval(this.temp.school, this.yearName)
                            .then(res => {
                                this.majorOptions = res;
                                resolve();
                            })
                            .catch(reject);
                    }).then(() => {
                        this.dialogVisible = true;
                    });
                } else {
                    this.dialogVisible = true;
                }
            });
        },

        //保存
        saveData() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    const p = this.uuid
                        ? edit(this.uuid, this.temp)
                        : add(this.yearName, this.temp);
                    p.then(() => {
                        this.$parent.fetchData(this.yearName);
                        this.dialogVisible = false;
                        this.$parent.$notify({
                            title: "成功",
                            message: this.uuid ? "修改成功" : "添加成功",
                            type: "success"
                        });
                    });
                }
            });
        }
    }
};
</script>
<style lang="less" scope>
</style>